import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import "../styles/Contact.scss";

gsap.registerPlugin(ScrollTrigger);

function Contact() {
  const [email, setEmail] = useState("");
  const divRef = useRef(null);
  useEffect(() => {
    const div = divRef.current.children;
    gsap.fromTo(
      div,
      { y: "+=300", autoAlpha: 0 },
      {
        duration: 0.5,
        y: "-=300",
        autoAlpha: 1,
        ease: "none",
        scrollTrigger: {
          id: "contact",
          trigger: div,
          start: "top bottom",
        },
      }
    );
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    setEmail("");
  };

  const handleInput = (e) => {
    setEmail(e.target.value);
  };
  return (
    <div className="contactContainer" id="contact" ref={divRef}>
      <div className="contactBox">
        <h2>Want to be a partner?</h2>
        <h3>Let us know.</h3>
        <p>
          Let's have a chat and pick a cup of coffee to discuss our project.
        </p>
        <form onSubmit={handleClick}>
          <input
            type="email"
            placeholder="yourmail@example.com"
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
            value={email}
            onChange={handleInput}
            required
          />
          <button type="submit">Get in Touch</button>
        </form>
      </div>
    </div>
  );
}

export default Contact;
